import { useLocation } from 'react-router-dom';
import { getEffectivePathFromWindow, isPrivatePath, isPublicPath } from './routeUtils';

export const useRoutes = () => {
  const location = useLocation();
  const effectivePath = getEffectivePathFromWindow(location.pathname);

  const isPublicRoute = isPublicPath(effectivePath);
  const isPrivateRoute = !isPublicRoute && isPrivatePath(effectivePath);

  return {
    isPrivateRoute,
    isPublicRoute,
  };
};
